<div class="modal-content">
  <div class="modal-header">
    <div class="modal-title h4" id="example-modal-sizes-title-lg">
      <ng-container *ngIf="item">
        <ng-container *ngIf="item.id">Edit</ng-container>
        <ng-container *ngIf="!item.id">Create</ng-container>
        {{ moduleName | lowercase }}
        <ng-container *ngIf="item.id">'{{ itemName }}'</ng-container>
      </ng-container>
    </div>
  </div>
  <div  class="overlay overlay-block cursor-default modal-body">
    <ng-container *ngIf="isLoading">
      <div class="overlay-layer bg-transparent">
        <div class="spinner spinner-lg spinner-success"></div>
      </div>
    </ng-container>

    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light btn-elevate mr-2"
      (click)="onCancelClicked()"
    >
      Cancel
    </button>
    <ng-container *ngIf="item">
      <button
      *ngIf="showSaveButton"
        type="submit"
        class="btn btn-primary btn-elevate"
        (click)="onSaveClicked()"
        [disabled]="saveDisabled"
      >
        {{saveButtonText}}
      </button>
    </ng-container>
  </div>
</div>
